import { Injectable } from '@angular/core';
import * as LZString from 'lz-string';
@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private storeDetails: string = "storeDetails";
  private basketId: string = "basketId";
  private state: string = "state";
  private storeFound: string = "storeFound";
  private orderType: string = "orderType";
  private reorderData: string = "reorderData";
  private dashboardArray: string = "dashboardArray"
  constructor() {
  }
  public setVisit(){
    sessionStorage.setItem('visit','first');
  }
  public getVisit(){
  let visit =  sessionStorage.getItem('visit');
  return visit;
  }
  public setUserStore(data: any) {
    sessionStorage.setItem(this.storeDetails, JSON.stringify(data));
  }
  public getUserStore() {
    let data = sessionStorage.getItem(this.storeDetails);
    return JSON.parse(data);
  }
  public setState(data) {
    sessionStorage.setItem(this.state, JSON.stringify(data));
  }
  public getStoreFound() {
    let data = sessionStorage.getItem(this.storeFound);
    return JSON.parse(data);
  }
  public setStoreFound(val) {
    let storeFound = {
      nearBy: val
    }
    sessionStorage.setItem(this.storeFound, JSON.stringify(storeFound));
  }
  public clearSetStoreFound() {
    sessionStorage.removeItem(this.storeFound)
  }
  public getreOrderData() {
    let data = localStorage.getItem(this.reorderData);
    return data;
  }
  public setreOrderData(data) {
    localStorage.setItem(this.reorderData, data);
  }
  public removereOrderData() {
    localStorage.removeItem(this.reorderData);
  }
  public getOrderType() {
    let data = sessionStorage.getItem(this.orderType);
    return data;
  }
  public setOrderType(data) {
    sessionStorage.setItem(this.orderType, data);
  }
  public removeOrderType() {
    sessionStorage.removeItem(this.orderType);
  }
  public getState() {
    let data = sessionStorage.getItem(this.state);
    return JSON.parse(data);
  }
  public setDashboard(data) {
    sessionStorage.setItem(this.dashboardArray, LZString.compress(JSON.stringify(data)));
  }
  public getDashboard() {
    let data = JSON.parse(LZString.decompress(sessionStorage.getItem(this.dashboardArray)));
    return data
  }
  public clearDashboard() {
    sessionStorage.removeItem(this.dashboardArray);
  }
  public clearState() {
    sessionStorage.removeItem(this.state);
  }
  public clearUserStore() {
    localStorage.removeItem(this.storeDetails);
  }
  public setBasketId(data) {
    sessionStorage.setItem(this.basketId, data);
  }
  public getBasketId() {
    let data = sessionStorage.getItem(this.basketId);
    return data
  }
  public clearBasketId(){
    sessionStorage.removeItem(this.basketId);
  }
  public cleanAll() {
    localStorage.clear()
  }
  public setSessionTokens(loginResponse){
    localStorage.setItem('access_token', JSON.stringify(loginResponse.response.access_token));
    localStorage.setItem('refresh_token', JSON.stringify(loginResponse.response.refresh_token));
    localStorage.setItem('token_type', JSON.stringify(loginResponse.response.token_type));//s
    localStorage.setItem('user_profile', JSON.stringify(loginResponse.response.profile));
    localStorage.setItem('referral_code', JSON.stringify(loginResponse.response.referralCode));
    localStorage.setItem('storeId', JSON.stringify(loginResponse.response.storeId));
  }
//
  public getAccessToken(){
    let data = JSON.parse(localStorage.getItem('access_token'));
    return data
  }
  public setAccessToken(token){
    localStorage.setItem('access_token', JSON.stringify(token));
  }
  public removeAccessToken(){
    localStorage.removeItem('access_token');
  }
//
  public getRefreshToken(){
    let data = JSON.parse(localStorage.getItem('refresh_token'));
    return data
  }
  public setRefreshToken(token){
    localStorage.setItem('refresh_token', JSON.stringify(token));
  }
  public removeRefreshToken(){
    localStorage.removeItem('refresh_token');
  }
public getTokenType(){
  let data = JSON.parse(localStorage.getItem('token_type'));
  return data
}
public setTokenType(token){
  localStorage.setItem('token_type', JSON.stringify(token));
}
public removeTokenType(){
  localStorage.removeItem('token_type');
}
  public setGuestToken(token){
    localStorage.setItem('guestUserToken', JSON.stringify(token));
  }
   public getGuestToken(){
    let data = JSON.parse(localStorage.getItem('guestUserToken'));
    return data
  }
  public removeGuestToken(){
    localStorage.removeItem('guestUserToken');
  }
  public getMenuList(){
    let menuListItem = localStorage.getItem('menuListItem') ? JSON.parse(LZString.decompress(localStorage.getItem('menuListItem'))) : '';
    return menuListItem;
  }
  public setLatLongData(result) {
    sessionStorage.setItem('currentLat', result.coords.latitude);
    sessionStorage.setItem('currentLong', result.coords.longitude);
    sessionStorage.setItem('locationAccepted', JSON.stringify(true));
    sessionStorage.setItem('gpsEvent', 'granted');
  }
  public getLatLongData() {
    let currentLat = sessionStorage.getItem('currentLat');
    let currentLong = sessionStorage.getItem('currentLong');
    let locationAccepted = JSON.parse(sessionStorage.getItem('locationAccepted'));
    let gpsEvent = sessionStorage.getItem('gpsEvent');
    let data = {
      'currentLat': currentLat,
      'currentLong': currentLong,
      'locationAccepted': locationAccepted,
      'gpsEvent': gpsEvent,
    }
    return data
  }
}
